<template>
  <div v-loading="loading" class="rj-page-card is-center">
    <div class="rj-page-card__title">
      项目基本信息
    </div>
    <div class="rj-page-card__content">
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单号码：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.orderNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.orderName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              总代：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.countryName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              二级渠道名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.buyerName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              集成商名称：
            </div>
            <div class="rj-baseinfo__item has-contacts">
              <template v-if="baseInfo.agentName">
                {{ baseInfo.agentName }}
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              集成商编码：
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="baseInfo.agentId">
                {{ baseInfo.agentId }}
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              所属行业：
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="baseInfo.industry">
                {{ baseInfo.industry }}
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              销售：
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="baseInfo.salesmanName">
                {{ baseInfo.salesmanName }}
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目所在区域：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.assistantAreaName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              细分市场：
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="baseInfo.marketSegmentName">
                {{ baseInfo.marketSegmentName }}
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目类型：
            </div>
            <div class="rj-baseinfo__item has-contacts">
              <template v-if="baseInfo.oppType">
                {{ baseInfo.oppType }}
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否投融资/ICT项目：
            </div>
            <div class="rj-baseinfo__item has-contacts">
              <template v-if="baseInfo.ictProject">
                {{ baseInfo.ictProject }}
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目所在城市：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.prefectureCityName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              期望发货时间：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.expectationSendTime }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务所在地市：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.serviceProvince }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务主体名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.serviceName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务主体编码：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.serviceCode }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务费用：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.serviceTotal }} 元
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务费率：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.serviceRate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rj-page-card__title" style="margin-top: 10px">
      产品明细
    </div>
    <div class="rj-page-card__content">
      <div class="miaoshu">
        <div class="tip rj-flex">
          <div>
            注：
          </div>
          <div class="rj-flex__item">
            <p>
              1、订单供货期规则（下单生成时间至要货时间）：仅含中低端产品：7天；高端产品：14天；定制化产品
              / 按单产品 / 受控产品：单独与平台商务或供应链沟通确认。
            </p>
            <p>
              2、服务主体职责：对项目实施及维护期限内质量及客户口碑负责。
            </p>
            <p>3、此项目按照2021年渠道政策执行。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {
    };
  },
  props: {
    baseInfo: {
      default: null,
      type: Object
    },
    loading: {
      default: false,
      type: Boolean
    }
  },
  components: {
  },
  computed: {},
  methods: {
  },
  mounted () {
  }
};
</script>
<style lang="scss">
@import "../../../../style/var";
.miaoshu {
  line-height: 30px;
  .tip {
    color: $--color-text-secondary;
    font-size: 13px;
  }
}
</style>
